<!-- Router's SLim Loading Bar (Like on YouTube) -->
<lf-slim-loader></lf-slim-loader>

<ngx-toasta [position]="'top-left'"></ngx-toasta>

<!-- Route Component -->
<div class="animated fadeIn h-100">
    <router-outlet></router-outlet>
</div>
